// Creates an action which is interpreted by /middleware/fetch.js.
export const FETCH_REQUEST_WITH_TYPES = 'FETCH_REQUEST_WITH_TYPES';
export const fetchRequestWithTypes = (action) => {
	return {
		type: FETCH_REQUEST_WITH_TYPES,
		...action,
	};
};

export * from './account';
export * from './agreements';
export * from './advisoryAgreements';
export * from './addressVerification';
export * from './auth';
export * from './bankAccount';
export * from './buffet';
export * from './card';
export * from './entitlements';
export * from './harmonyBank';
export * from './investorApplication';
export * from './onboarding';
export * from './phoneVerification';
export * from './profile';
export * from './plans';
export * from './platformTiers';
export * from './portfolioBuilder';
export * from './px-questions';
export * from './quotes';
export * from './referrals';
export * from './stockParty';
export * from './transfers';
export * from './trustedContact';
export * from './user';
